import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/InactivityPopup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/newCommonComponent/AllAboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/VisitPageHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/visit/CmaEquivalentNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/visit/CmaMilesoneNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/visit/JobMncsCmaNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/CairaSectionLp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/newPageComponent/CommonSection/FaqToggleWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/Live_webinar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/Pan_India_presence.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/newPageComponent/CommonSection/StickyFooterLabel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/TestimonialAccounting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/newPageComponent/cpa-new/visit/VisitPageBannerNew.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/vercel/path0/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
